import { __ } from '@wordpress/i18n'

import { 
    ServerSideRender, PanelBody, SelectControl, TextareaControl 
} from '@wordpress/components'

import { 
     i18n
} from 'cartzillagb'

import { addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
    withTabbedInspector
} from '~cartzillagb/higher-order'
import classnames from 'classnames'

import { 
    withSelect 
} from '@wordpress/data'

addFilter( 'cartzillagb.megamenu-nav-menu.edit.inspector.style.before', 'cartzillagb/megamenu-nav-menu', ( output, props ) => {
    const { attributes, setAttributes, isSelected, menuOptions, classnames } = props
    const {
        className, 
        megaMenuSlug,
    } = attributes

    return (
        
        <PanelBody title={ __( "Select a Menu", i18n ) } initialOpen={ true }>
                    
            <SelectControl
                label={ __( 'Select a primary menu', i18n ) }
                options={ menuOptions }
                value={ megaMenuSlug }
                onChange={ megaMenuSlug => setAttributes( { megaMenuSlug } ) }

            />
            
        </PanelBody>
    )
} )


const edit = props => {
    
    return (
        <ServerSideRender
            block="czgb/megamenu-nav-menu"
            attributes={{
               megaMenuSlug: props.attributes.megaMenuSlug
            }}
            
        />


    )
}

export default compose(
    withSelect( select => {
        const { getEntityRecords } = select( 'core' )
        const menusList = getEntityRecords( 'taxonomy', 'nav_menu', { 'hide_empty': false, 'orderby': 'name', 'per_page': -1 } )

        let menuOptions = [];

        if( menusList && menusList.length > 0 ) {
            menuOptions = menusList.map( ( menu ) => ( {
                label: menu.name,
                value: menu.slug
            } ) )
        }

        menuOptions.unshift({
            label: __( 'Default' ),
            value: 0
        })

        return {
            menuOptions: menuOptions,
        }
    }),

    withTabbedInspector( [ 'style', 'advanced' ] ),

)( edit )